<template>
          <div class="container-fluid no-scroll">
        <div class="row overflow-scroll" style="justify-content: space-between;">

          <div
            v-for="option in options"
            :key="option.id"
            class="col-xs-8 col-sm-4 col-md-3 col-lg-2 mb-2 cat"
          >
            <div class="card borderless" style="border: none">

                <div class="card-body" style="padding: 5px; text-align: center">

                <router-link
                  :to="option.destination"
                  style="text-decoration: unset; height: 210px !important"
                >
                  <i
                    :class="['bi', 'me-2']"
                    style="
                      font-size: 2rem;
                      margin: 0px !important;
                      color: #5fa8d3;
                      width: 24px;
                      height: 24px;
                    "
                  >
                    <svg
                      :width="option.svgObj.width"
                      :height="option.svgObj.height"
                      :viewBox="option.svgObj.viewBox"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path :d="option.path.d" fill="#5FA8D3" />
                    </svg>
                  </i>
                  <p class="card-text cat-text">{{ option.description }}</p>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
</template>

<script>
export default {
  name: 'CategoriesComponent',
  props: {
    options: {
      type: Array,
      required: true
    }
  }
};
</script>
